'use stric'

const getCarsGroupsSelectObj = (array) => {
  var selectOptions = array.map((item) => {
    return {
      label: item.title,
      value: item.id
    }
  })

  return selectOptions
}

export { getCarsGroupsSelectObj }